import { FormControlLabel, Switch, SwitchProps } from "@mui/material";
import React from "react";

type MdmSwitchProps = {
  label: string;
  handleOnChange: (checked: boolean) => void;
  disabled?: boolean;
  isChecked?: boolean;
  defaultValue?: string | undefined;
};

export const MdmSwitch = ({
  label,
  handleOnChange,
  disabled,
  isChecked,
  defaultValue,
  ...otherProps
}: MdmSwitchProps & SwitchProps) => {
  return (
    <FormControlLabel
      control={
        <Switch
          {...otherProps}
          checked={isChecked === undefined ? false : isChecked}
          defaultValue={defaultValue && defaultValue}
          disabled={disabled}
        />
      }
      onChange={(_, checked) => handleOnChange(checked)}
      label={label}
    />
  );
};
